import { ButtonProps, Button as MuiButton } from '@mui/material';
import React from 'react';

export const Button = ({
    size = 'medium',
    variant = 'contained',
    children,
    ...props
}: ButtonProps) => {
    return (
        <MuiButton size={size} variant={variant} {...props}>
            {children}
        </MuiButton>
    );
};
